import { Alert } from "@blueprintjs/core";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import actAsUserAtom from "./uiState/actAsUserAtom";
import {
  ACT_AS_IDLE_MS,
  ACT_AS_WARNING_MS,
  heartbeatActAsSession,
  signOutCurrentUser,
  subscribeActAsActivity,
} from "./actAsSession";
import Toaster from "./Toaster";
import { SignoutAlert } from "./SignoutAlert";

export function ActAsSessionController() {
  const session = useAtomValue(actAsUserAtom);
  const [signoutSessionId, setSignoutSessionId] = useState<string | null>(null);
  const [now, setNow] = useState(Date.now());
  const [renewing, setRenewing] = useState(false);
  useEffect(() => subscribeActAsActivity(() => setNow(Date.now())), []);
  const age = session ? now - session.lastActivity : 0;
  if (!session || age < ACT_AS_WARNING_MS) return null;
  if (signoutSessionId === session.sessionId) {
    return (
      <SignoutAlert
        message={`Sign out of ${session.actAsUserName}?`}
        onConfirm={async () => {
          await signOutCurrentUser();
          setSignoutSessionId(null);
        }}
        onCancel={() => setSignoutSessionId(null)}
      />
    );
  }
  return (
    <Alert
      isOpen
      intent="warning"
      canEscapeKeyCancel={false}
      canOutsideClickCancel={false}
      confirmButtonText="Stay signed in"
      cancelButtonText="Log out"
      loading={renewing}
      onCancel={() => {
        setSignoutSessionId(session.sessionId);
      }}
      onConfirm={() => {
        setRenewing(true);
        void heartbeatActAsSession(true, true)
          .catch((error: unknown) =>
            Toaster.error(
              error instanceof Error
                ? error.message
                : "Unable to renew act-as.",
            ),
          )
          .finally(() => setRenewing(false));
      }}
    >
      <strong>{session.actAsUserName}</strong> will be signed out in{" "}
      {Math.max(0, Math.ceil((ACT_AS_IDLE_MS - age) / 1000))} seconds.
    </Alert>
  );
}
